<footer>
  <div class="container-fluid ms-0">
    <div class="row">
      <div class="col-sm-4">
        © 2025 EXL. All rights reserved.
      </div>
      <div class="col-sm-8 text-sm-end">
        <a href="https://www.exlservice.com/terms-of-use" target="_blank">Terms of Use</a>
        <a href="https://www.exlservice.com/privacy-policy" target="_blank" class="px-4">Exl Privacy Policy</a>
        <a href="https://www.exlservice.com/legal-disclaimer" target="_blank">Legal Disclaimer</a>
      </div>
    </div>
  </div>
</footer>
